require('@/vue-ldc/js/message.js');
require('@/vue-ldc/js/loading.js');
require('@/vue-ldc/js/clickOutside.js');
require('@/vue-ldc/js/confirm.js');
require('@/vue-ldc/js/loadingFullscreen.js');
Vue.component('ldc-select', require('@/vue-ldc/js/select.vue').default);
Vue.component('ldc-option', require('@/vue-ldc/js/option.vue').default);
Vue.component('ldc-dropdown', require('@/vue-ldc/js/dropdown.vue').default);
Vue.component('ldc-dropdown-menu', require('@/vue-ldc/js/dropdownMenu.vue').default);
Vue.component('ldc-model-mobile', require('@/vue-ldc/js/modelMobile.vue').default);
Vue.component('ldc-dialog', require('@/vue-ldc/js/dialog.vue').default);
Vue.component('ldc-select-mobile', require('@/vue-ldc/js/selectMobile.vue').default);
Vue.component('ldc-option-mobile', require('@/vue-ldc/js/optionMobile.vue').default);
Vue.component('ldc-select-show-option', require('@/vue-ldc/js/selectShowOption.vue').default);
Vue.component('ldc-option-show', require('@/vue-ldc/js/optionShow.vue').default);
Vue.component('ldc-time', require('@/vue-ldc/js/time.vue').default);
Vue.component('ldc-pagination', require('@/components/profile/pagination.jsx').default);